export type ReportAccessType = 'Public' | 'Private';

export enum ReportFormType {
  BalanceFinance = 'balanceFinance',
  DebtorRegistry = 'debtorRegistry',
  SubscriberCharges = 'subscriberCharges',
  UndistributedPayments = 'undistributedPayments',
  Payments = 'payments',
}

export type Report = {
  id: string;
  name: string;
  formType: ReportFormType;
  description: string;
  formNumber?: number | string;
  lastGenerationDate?: string;
  authorName?: string;
  accessType?: ReportAccessType;
};
